import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'

import './plugins/vuex'
import { router } from './plugins/vue-router'
import './plugins/vuex-router-sync'
import './plugins/axios'
import './plugins/bootstrap-vue'
import './plugins/vee-validate'
import './plugins/perfect-scrollbar'
import './plugins/vue-infinite-loading'
import './plugins/vue-select'
import './plugins/fontawesome'
import './plugins/element-ui'
import './plugins/v-runtime-template'
import './plugins/vue-googlemaps'
import './plugins/vue2-slideout-panel'
import './plugins/application'

import App from './App.vue'
import store from './store'

Vue.config.productionTip = false
Vue.config.silent = true

Vue.peer.user.initiate()

new Vue({
    created: function() {
        window.Vue = this
    },
    router,
    store,
    render: h => h(App)
}).$mount('#app')
